import { SelectionModel } from '@angular/cdk/collections';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { MatTableDataSource } from '@angular/material/table';
import * as moment from 'moment';
import { Subscription, Observable, Subject, of } from 'rxjs';
import { map, pluck, shareReplay, startWith, tap } from 'rxjs/operators';
import { CodiceTipiRichiedente } from '../../constants/tipi-richiedente';
import { InfoAnagrafichePFDTO } from '../../models/info-anagrafiche-pf';
import { InfoNascitaPFDTO } from '../../models/info-nascita-pf.dto';
import { MieDelegheDTO } from '../../models/mie-deleghe-dto';
import { NaturaRichiedenteDTO } from '../../models/natura-richiedente.dto';
import { nuovaPFBase, PersonaFisicaBaseDTO } from '../../models/persona-fisica-base-dto';
import { PersonaFisicaDTO } from '../../models/persona-fisica-dto';
import { nuovaPGBase, PersonaGiuridicaBaseDTO } from '../../models/persona-giuridica-base-dto';
import { PersonaGiuridicaDTO } from '../../models/persona-giuridica-dto';
import { DatiPersonaFisica } from '../../models/portale/dati-persona-fisica';
import { Localita } from '../../models/portale/localita';
import { Nazione } from '../../models/portale/nazione';
import { PersonaFisica } from '../../models/portale/persona-fisica-model';
import { PersonaGiuridica } from '../../models/portale/persona-giuridica-model';
import { RappresentanteDTO } from '../../models/rappresentante-dto';
import { TipologicaDTO } from '../../models/tipologica-d-t-o';
import { Utente } from '../../models/utente';
import { ComponentOutputStatus } from '../../normalizzazione/component-output-status';
import { DelegheService } from '../../services/deleghe-services/deleghe.service';
import { MessageService } from '../../services/message.service';
import { UtenteService } from '../../services/utente/utente.service';
import { ComponentReducer } from '../../utils/component-reducer';
import { coalesce } from '../../utils/fnutils';
import { Modals } from '../../utils/modals';
function log(text, value) {
	console.log(text, value);
}
@Component({
	selector: 'lib-deleghe',
	templateUrl: './deleghe.component.html',
	styleUrls: ['./deleghe.component.css']
})
export class DelegheComponent implements OnInit, OnDestroy {

	form: FormGroup;

	@Input()
	rappresentanza: RappresentanteDTO;

	@Input()
	province: Observable<Array<Localita>>;

	@Input()
	nazioni: Observable<Array<Nazione>>;

	@Input()
	tipologieRichiedenti$: Observable<Array<NaturaRichiedenteDTO>>;

	@Input()
	deleghe$: Observable<MieDelegheDTO>;

	@Input()
	tipologiaDeposito$: Observable<TipologicaDTO>;

	@Input()
	generalContractorValue: boolean;

	@Output()
	nextStep: EventEmitter<RappresentanteDTO> = new EventEmitter<
		RappresentanteDTO
	>();

	@Output()
	previousStep: EventEmitter<RappresentanteDTO> = new EventEmitter<
		RappresentanteDTO
	>();

	@Output()
	salvaBozza: EventEmitter<RappresentanteDTO> = new EventEmitter<
		RappresentanteDTO
	>();

	@Output() public isGeneralContractor = new EventEmitter<boolean>();

	tipoRichiedente: FormControl;
	deleghe: FormControl;
	generalContractor: FormControl;

	displayedColumns: string[] = ['tipo', 'indirizzo', 'seleziona'];
	// dataSource: MatTableDataSource<any>;
	selection: SelectionModel<any>;
	CODICE_LEGALE = "LEGALE"


	direction: string = "both-ways";
	isFinal: boolean = false;
	nsDanteCausa: string;
	nsTutore: string;
	nsLegale: string;
	tipoRichiedente$: Observable<NaturaRichiedenteDTO>;
	tipoRichiedenteSub: Subscription;
	isFormValid: boolean;
	listaDeleghe: Array<PersonaFisicaBaseDTO | PersonaGiuridicaBaseDTO>;
	listaDeleghe$: Observable<Array<any>>;
	personaFisica$: Observable<PersonaFisica>;
	personaFisica: DatiPersonaFisica;
	pfSubscription: Subscription;
	personaGiuridica$: Observable<PersonaGiuridica>;
	personaGiuridica: PersonaGiuridica;
	pgSubscription: Subscription;
	defaultDeleghe: boolean = false;
	personaFisicaBase: PersonaFisicaBaseDTO;
	personaGiuridicaBase: PersonaGiuridicaBaseDTO;
	namespaceInfoPf: string;
	nspg: string;
	showComponentPF: boolean = false;
	showComponentPG: boolean = false;
	isSearching: boolean = false;
	delega: string;
	formControlGeneralContractor: boolean = false;
	utente: Utente;
	listaDelegheDefault: Array<PersonaFisicaBaseDTO | PersonaGiuridicaBaseDTO>;
	codiceTipoDeposito: string;
	tipologiaRichiedenteInit$: Observable<Array<NaturaRichiedenteDTO>>;
	flagDelegaSeStesso: boolean = false;

	changesPersonaFisica$ = new Subject<
		ComponentOutputStatus<(value: RappresentanteDTO) => void>
	>();

	changesPersonaGiuridica$ = new Subject<
		ComponentOutputStatus<(value: RappresentanteDTO) => void>
	>();

	isValidSedi: boolean;

	$selected: Subscription;
	validazioneeSede: boolean = false;
	idSedeSelezionata: string;
	isNew: boolean;
	couldBeDittaIndividuale:boolean = true;

	constructor(
		private delegheService: DelegheService,
		private modals: Modals,
		private msg: MessageService,
		private utenteService: UtenteService,
		private ref: ChangeDetectorRef
	) { }

	ngOnInit() {

		this.utente = this.utenteService.getUtente();

		console.log('[DelegheComponent] - Utente', this.utente);

		this.tipologiaDeposito$
			.subscribe(
				deposito => {
					console.log('[tipologiaDeposito$]', deposito);
					//TODO
					if (deposito.codice == "CDE") {
						this.formControlGeneralContractor = true;
					}
					this.codiceTipoDeposito = deposito.codice;
				}
			);

		//TODO
		const richiedenteSubscription = this.tipologieRichiedenti$
			// .pipe(
			// 	pluck("residenza"))
			.subscribe(
				richiedente => {
					console.log('[NaturaRichiedenteDTO]', richiedente);
					if(this.rappresentanza) {
					  let selectedItem = richiedente.find(r => r.codice == this.rappresentanza.codiceDelega);
					  if(selectedItem) {
						this.couldBeDittaIndividuale = selectedItem?.dittaIndividuale;
					  }
					}
				},
				_ => {
					// this.modals.failure([
					// 	"recupero.natura.failure"
					// ], []);
				}
			);

		this.form = new FormGroup({});

		let valid = true;
		if (!this.rappresentanza) {
			this.initRappresentante();
			valid = false;
		} else {
			this.idSedeSelezionata = this.rappresentanza.idSedeSelezionata;
			if (this.rappresentanza.nuovaPersona) {
				this.isNew = true;
				this.delega = 'nuovo';

				if (this.rappresentanza.tipoRappresentante == "PF") {
					this.listaDelegheDefault = [nuovaPFBase()];
					this.showComponentPF = true;
					log("showComponentPF", this.showComponentPF);
				} else {
					this.listaDelegheDefault = [nuovaPGBase()];
					this.showComponentPG = true;
				}

				this.defaultDeleghe = true;

				this.listaDeleghe = [];

				const richiedenteSubscription = this.tipologieRichiedenti$.pipe(
					map(r => r.filter(t => t.codice == this.rappresentanza.codiceDelega))
				).subscribe(
					richiedente => {


						const filterByTipoRichiedente =
							(tipiRichiedente: Array<PersonaFisicaBaseDTO | PersonaGiuridicaBaseDTO>) =>
								tipiRichiedente.filter(tr => tr.codTipoDelega == richiedente[0].codice);

						if (this.isPersonaFisica(richiedente[0].tipoPersona)) {
							this.deleghe$.pipe(
								pluck("personeFisiche"),
								map(filterByTipoRichiedente)
							).
								subscribe((res: Array<PersonaFisicaBaseDTO>) => {
									if (res.length > 0) {
										this.listaDeleghe = [...res, ...this.listaDeleghe];
									}
									// console.log('[ListaDeleghe - personeFisiche ]', this.listaDeleghe);
								});
						}

						if (this.isPersonaGiuridica(richiedente[0].tipoPersona)) {
							this.deleghe$.pipe(
								pluck("personeGiuridiche"),
								map(filterByTipoRichiedente)
							).
								subscribe((res: Array<PersonaGiuridicaBaseDTO>) => {
									if (res.length > 0) {
										if (this.listaDeleghe.length > 0) {
											this.listaDeleghe = [...res, ...this.listaDeleghe];
										} else {
											this.listaDeleghe = [...res];
										}
									}
								});
						}

						if (richiedente[0].tipoPersona.length > 1) {
							if (this.rappresentanza.tipoRappresentante == "PF") {
								this.listaDeleghe = [...this.listaDeleghe, nuovaPFBase(), nuovaPGBase()];
							} else {
								this.listaDeleghe = [...this.listaDeleghe, nuovaPGBase(), nuovaPFBase()];
							}
						} else {
							if (richiedente[0].tipoPersona.find(element => element == "PF")) {
								this.listaDeleghe = [...this.listaDeleghe, nuovaPFBase()];
							} else {
								this.listaDeleghe = [...this.listaDeleghe, nuovaPGBase()];
							}
						}
						this.listaDelegheDefault= [this.listaDeleghe.find(el => el.idPersona == "nuovo")];
                        this.deleghe.setValue(this.listaDelegheDefault[0]);

						richiedenteSubscription.unsubscribe();
					},
					_ => {

					}
				);
			}
		}

		this.nsDanteCausa = "nsRapprDc";
		this.nsTutore = "nsRapprTut";
		this.nsLegale = "nsRapprLeg";

		this.namespaceInfoPf = this.nsTutore + "PFinfoPF";
		this.nspg = this.nsLegale + "pg";

		if(this?.rappresentanza?.codiceDelega) {
			const initalTipoRichiedente = this.fromIdAndTipo(this.rappresentanza.codiceDelega, this.rappresentanza.tipoRappresentante);
			this.tipoRichiedente = new FormControl(
				{ value: initalTipoRichiedente, disabled: false },
				[Validators.required]
			);
		}
		else {
			this.tipoRichiedente = new FormControl(
				{ value: null, disabled: false },
				[Validators.required]
			);
		}

		this.form.addControl("tipoRichiedente", this.tipoRichiedente);

		this.deleghe = new FormControl(
			{ value: '', disabled: false },
			// { value: this.defaultDeleghe ? this.listaDelegheDefault[0] : '', disabled: false },
			[Validators.required]
		);
		this.form.addControl("deleghe", this.deleghe);

		this.generalContractor = new FormControl(
			{ value: this.generalContractorValue, disabled: false });
		this.form.addControl('generalContractor', this.generalContractor);

		this.selection = new SelectionModel<any>(false, []);
		const selected = new FormControl({ value: '', disabled: false });
		this.form.addControl('selected', selected);

		if (this.tipoRichiedente.value != undefined &&
			!this.rappresentanza.nuovaPersona  &&
			this.tipoRichiedente.value != CodiceTipiRichiedente.CODICE_ME_MEDESIMO) {

			const richiedenteSubscription = this.tipologieRichiedenti$.pipe(
				map(r => r.filter(t => t.codice == this.rappresentanza.codiceDelega)),
				tap((tipo: Array<NaturaRichiedenteDTO>) => {
					console.log('initDeleghe:',tipo[0]);
					this.initDeleghe(tipo[0]);
				}),
			).subscribe(
				richiedente => {

					if (this.isPersonaFisica(richiedente[0].tipoPersona)) {
						this.personaFisicaBase = this.initPersonaFisica(this.rappresentanza.idPersona);
					}

					if (this.isPersonaGiuridica(richiedente[0].tipoPersona)) {
						this.personaGiuridicaBase = this.initPersonaGiuridica(this.rappresentanza.idPersona);
					}
					richiedenteSubscription.unsubscribe();
				},
				_ => {

				}
			);

		}

		this.tipoRichiedente$ = this.tipoRichiedente.valueChanges.pipe(
			tap(_ => {
				this.deleghe.setValue(null);
				this.resetValidation();
				this.flagDelegaSeStesso = false;
				this.ref.detectChanges();
			}),
			tap((tipo: NaturaRichiedenteDTO) => {
				if (tipo.codice != CodiceTipiRichiedente.CODICE_ME_MEDESIMO) {
					this.initDeleghe(tipo);
					this.rappresentanza.idSedeSelezionata = null;
				} else {
					this.resetDeleghe();
					this.rappresentanza.idPersona = this.utente?.idPersonaFisica;
					this.rappresentanza.tipoRappresentante = "PF";

				}
			}),
			shareReplay()
		);

		const changesDelega$ =
			this.deleghe.valueChanges.pipe(
				map(delega => {
					return ComponentOutputStatus.of(
						true,
						rappresentanza => {
							if (delega != undefined && delega != null) {
								this.delega = delega.idPersona;
								if (!this.defaultDeleghe) {
									this.setDelega(delega);
								} else {
									this.defaultDeleghe = false;
								}
								this.flagDelegaSeStesso = false;
								this.ref.detectChanges();
								rappresentanza.idPersona = delega.idPersona != 'nuovo' ? delega.idPersona : null;
							}
						})
				})
			);

		const tipoRichiedenteChanges$: Observable<ComponentOutputStatus<
			(value: RappresentanteDTO) => void
		>> = this.tipoRichiedente$.pipe(
			map((tipoRichiedente: NaturaRichiedenteDTO) => {
				return ComponentOutputStatus.of(
					this.tipoRichiedente.valid,
					(rap: RappresentanteDTO) => {
						// rap.tipoRappresentante = tipoRichiedente.descrizione;
						rap.codiceDelega = tipoRichiedente.codice;
					}
				);
			})
		);


		const rappresentante$: Observable<ComponentOutputStatus<
			RappresentanteDTO
		>> = ComponentReducer.reducer4(
			tipoRichiedenteChanges$,
			changesDelega$,
			this.changesPersonaFisica$,
			this.changesPersonaGiuridica$,
			(richiedente) => {
				let isValid: boolean;

				if (coalesce(richiedente, '')('codiceDelega').valueOf() != CodiceTipiRichiedente.CODICE_ME_MEDESIMO) {
					if (this.delega == 'nuovo') {
						isValid = (this.rappresentanza.personaFisica != null ||
							this.rappresentanza.personaGiuridica != null) &&
							this.deleghe.value && !this.flagDelegaSeStesso;
					} else {
						// isValid = this.rappresentanza.idPersona != null && this.deleghe.value;
						isValid =
							richiedente.idPersona != null &&
							this.deleghe.value &&
							!this.flagDelegaSeStesso
					}
				} else {
					isValid = true;
				}
				this.ref.detectChanges();
				return isValid;

			},
			ComponentOutputStatus.of(valid, this.rappresentanza)
		);

		rappresentante$.subscribe((delegante) => {
			console.log("[DelegheComponent] rappresentanza", delegante);
			this.isFormValid = delegante.status;
		});

	}
	resetValidation() {
		this.changesPersonaFisica$.next(
			ComponentOutputStatus.of(true, (personaFisica) => (rap: RappresentanteDTO) => { })
		);
		this.changesPersonaGiuridica$.next(
			ComponentOutputStatus.of(true, (personaGiuridica) => (rap: RappresentanteDTO) => { })
		);
	}

	forward(_: any) {
		this.nextStep.emit(this.rappresentanza);
	}

	onSalvaBozza($event: any) {
		this.salvaBozza.emit(this.rappresentanza);
	}

	backward($event: any) {
		this.previousStep.emit(this.rappresentanza);
	}

	complete($event: any) { }

	initRappresentante() {
		this.rappresentanza = new RappresentanteDTO();
	}

	ngOnDestroy(): void {
		if (this.tipoRichiedenteSub) {
			this.tipoRichiedenteSub.unsubscribe();
		}
		if (this.$selected) {
			this.$selected.unsubscribe();
		}
	}

	setDelega(persona: any) {
		this.delega = persona.idPersona;

		this.resetDeleghe();
		this.showComponentPF = false;
		this.showComponentPG = false;

		if (persona.cognome) {
			if (persona.idPersona != "nuovo") {
				this.getPersonaFisica(persona.idPersona);
			}
			else {
				this.mapperPersonaFisica(null);
				setTimeout(() => this.showComponentPF = true, 0);
			}
		}

		if (persona.ragioneSociale) {
			if (persona.idPersona != "nuovo") {
				this.getPersonaGiuridica(persona.idPersona);
			}
			else {
				this.mapperPersonaGiuridica(null);
				setTimeout(() => this.showComponentPG = true, 0);
			}
		}
	}
	public hasSelecteDelegante(): boolean {
		return this.deleghe.value;
	}

	public viewDeleghe(): boolean {
		return (coalesce(this.tipoRichiedente.value, '')('codice').valueOf() === "" ||
			coalesce(this.tipoRichiedente.value, '')('codice').valueOf() === CodiceTipiRichiedente.CODICE_ME_MEDESIMO);
	}

	getPersonaFisica(id: string) {
		this.resetValidation();
		this.rappresentanza.idSedeSelezionata = null;
		this.showComponentPF = false;

		this.personaFisica$ = this.delegheService.getPersona(id)
			.pipe(shareReplay());

		this.pfSubscription = this.personaFisica$.pipe(
		).subscribe(
			(pf) => {
				this.mapperPersonaFisica(pf.datiPersonaFisica);
				this.personaFisica = pf.datiPersonaFisica;
				this.rappresentanza.idPersona = id;
				this.rappresentanza.tipoRappresentante = "PF"
				this.rappresentanza.codiceRegione = pf?.residenza?.regione?.sigla;
				this.showComponentPF = true;
				this.showComponentPG = false;
			},
			_ => {

			}
		);
	}

	getPersonaGiuridica(id: string) {
		this.resetValidation();
		this.rappresentanza.idSedeSelezionata = null;
		this.showComponentPG = false;
		this.personaGiuridica$ = this.delegheService.getDatiSocieta(id)
			.pipe(shareReplay());

		this.pgSubscription = this.personaGiuridica$.pipe(
		).subscribe(
			(pg: PersonaGiuridica) => {
				this.form.get('selected').setValue('');
				this.mapperPersonaGiuridica(pg);
				this.personaGiuridica = pg;
				this.rappresentanza.idPersona = id;
				this.rappresentanza.tipoRappresentante = "PG"
				this.showComponentPG = true;
				this.showComponentPF = false;
				if (pg?.sedi != undefined) {
					const sede = pg.sedi.filter(sedeLegale => sedeLegale.tipoSede.codice === "LEGALE");
					this.rappresentanza.codiceRegione = sede[0]?.indirizzo?.regione?.sigla;
				}
				this.ref.detectChanges();
			},
			_ => {

			}
		);
	}

	isPersonaFisica(tipoPersona: Array<string>): boolean {

		let isValid: boolean;

		if (tipoPersona.find(element => element == "PF")) {
			isValid = true;
		} else {
			isValid = false;
		}

		return isValid;
	}

	isPersonaGiuridica(tipoPersona: Array<string>): boolean {

		let isValid: boolean;

		if (tipoPersona.find(element => element == "PG")) {
			isValid = true;
		} else {
			isValid = false;
		}

		return isValid;
	}

	initDeleghe(tipoRichiedente: NaturaRichiedenteDTO) {
		this.listaDeleghe = [];

		console.log('tipoRichiedente:',tipoRichiedente);

		this.couldBeDittaIndividuale = tipoRichiedente?.dittaIndividuale;

		const filterByTipoRichiedente =
			(tipiRichiedente: Array<PersonaFisicaBaseDTO | PersonaGiuridicaBaseDTO>) =>
				tipiRichiedente.filter(tr => tr.codTipoDelega == tipoRichiedente.codice);
		if (this.isPersonaFisica(tipoRichiedente.tipoPersona)) {
			this.deleghe$.pipe(
				pluck("personeFisiche"),
				map(filterByTipoRichiedente)
			).
				subscribe((res: Array<PersonaFisicaBaseDTO>) => {
					this.listaDeleghe = [...res, nuovaPFBase()];
					this.deleghe.setValue(this.listaDeleghe.find(el => el.idPersona == this.rappresentanza.idPersona));
				});
		}

		if (this.isPersonaGiuridica(tipoRichiedente.tipoPersona)) {
			this.deleghe$.pipe(
				pluck("personeGiuridiche"),
				map(filterByTipoRichiedente)
			).
				subscribe((res: Array<PersonaGiuridicaBaseDTO>) => {
					if (this.listaDeleghe.length > 0) {
						this.listaDeleghe = this.listaDeleghe.reduce((acc: Array<any>, currentValue, index) => {
							if (this.listaDeleghe.length - 1 == index) {
								acc.push(...res, nuovaPGBase());
							}
							return acc
						}, this.listaDeleghe)
					} else {
						this.listaDeleghe = [...res, nuovaPGBase()];
					}
					this.deleghe.setValue(this.listaDeleghe.find(el => el.idPersona == this.rappresentanza.idPersona));
				});
		}
	}

	resetDeleghe() {
		this.rappresentanza.idPersona = null;
		this.rappresentanza.nuovaPersona = false;
		this.rappresentanza.personaFisica = null;
		this.rappresentanza.personaGiuridica = null;
		this.rappresentanza.tipoRappresentante = null;
		this.personaGiuridica = null;
		this.personaGiuridica$ = null;
		this.personaFisica = null;
	}

	mapperPersonaFisica(datiPersona: DatiPersonaFisica) {
		const personaFisica = new PersonaFisicaDTO();
		const infoAnagrafiche = new InfoAnagrafichePFDTO();
		personaFisica.infoAnagrafiche = infoAnagrafiche;
		const infoNascita = new InfoNascitaPFDTO();
		personaFisica.infoNascita = infoNascita;

		if (datiPersona) {
			infoAnagrafiche.codFiscale = datiPersona.codiceFiscale;
			infoAnagrafiche.cognome = datiPersona.cognome;
			infoAnagrafiche.nome = datiPersona.nome;
			personaFisica.infoAnagrafiche = infoAnagrafiche;
			infoNascita.comuneNascita = datiPersona.comuneNascita?.codiceCatastale;
			infoNascita.provinciaNascita = datiPersona.provinciaNascita?.sigla;
			infoNascita.dataNascita = moment(datiPersona.dataNascita, "DD/MM/YYYY").toDate();
			personaFisica.infoNascita = infoNascita;
		}
		this.rappresentanza.personaFisica = personaFisica;
	}

	initPersonaFisica(id: string): PersonaFisicaBaseDTO {

		let personaFisica = new PersonaFisicaBaseDTO();

		this.showComponentPF = false;

		this.personaFisica$ = this.delegheService.getPersona(id)
			.pipe(shareReplay());

		this.pfSubscription = this.personaFisica$.pipe(
			pluck("datiPersonaFisica")
		).subscribe(
			(pf: DatiPersonaFisica) => {
				this.mapperPersonaFisica(pf);
				this.rappresentanza.idPersona = id;
				personaFisica.codTipoDelega = this.rappresentanza.codiceDelega;
				personaFisica.codiceFiscale = pf.codiceFiscale;
				personaFisica.cognome = pf.cognome;
				personaFisica.nome = pf.nome;
				personaFisica.idPersona = pf.id;

				this.showComponentPF = true;
				this.showComponentPG = false;
			},
			_ => {

			}
		);

		return personaFisica
	}

	initPersonaGiuridica(id: string): PersonaGiuridicaBaseDTO {

		let personaGiuridica = new PersonaGiuridicaBaseDTO();

		this.showComponentPG = false;

		this.personaGiuridica$ = this.delegheService.getDatiSocieta(id)
			.pipe(shareReplay());

		this.pgSubscription = this.personaGiuridica$.pipe(
		).subscribe(
			(pg: PersonaGiuridica) => {
				this.mapperPersonaGiuridica(pg);
				personaGiuridica.codTipoDelega = this.rappresentanza.codiceDelega;
				personaGiuridica.codiceFiscale = pg.datiPersonaGiuridica.codiceFiscale;
				personaGiuridica.ragioneSociale = pg.datiPersonaGiuridica.ragioneSociale;
				personaGiuridica.pIva = pg.datiPersonaGiuridica.partitaIVA;
				personaGiuridica.idPersona = pg.datiPersonaGiuridica.id;
				this.rappresentanza.idPersona = id;
				this.showComponentPG = true;
				this.showComponentPF = false;
				this.deleghe.setValue(this.listaDeleghe.find(el => el.idPersona == personaGiuridica.idPersona));
			},
			_ => {

			}
		);

		return personaGiuridica
	}

	mapperPersonaGiuridica(datiPersona: PersonaGiuridica) {
		// console.log('[mapperPersonaGiuridica]', datiPersona);
		const personaGiuridica = new PersonaGiuridicaDTO();
		if (datiPersona) {
			personaGiuridica.codiceFiscale = datiPersona.datiPersonaGiuridica.codiceFiscale;
			personaGiuridica.ragioneSociale = datiPersona.datiPersonaGiuridica.ragioneSociale;
			personaGiuridica.partitaIVA = datiPersona.datiPersonaGiuridica.partitaIVA;
			personaGiuridica.idPersonaGiuridica = datiPersona.datiPersonaGiuridica.id;
			personaGiuridica.sedi = datiPersona.sedi;
		}
		this.rappresentanza.personaGiuridica = personaGiuridica;
	}

	personaFisicaReady(personaFisicaStatus: ComponentOutputStatus<PersonaFisicaDTO>) {
		console.log('[personaFisicaReady]', personaFisicaStatus);
		this.resetValidation();
		this.rappresentanza.idSedeSelezionata = null;
		this.changesPersonaFisica$.next(
			personaFisicaStatus.mapValue(

				(personaFisica) => (rap: RappresentanteDTO) => {
					this.rappresentanza.idPersona = personaFisica.id;
					rap.personaFisica = personaFisica;

					if (this.delega == "nuovo") {
						rap.codiceRegione = personaFisica.infoAnagrafiche.codiceRegione;
						rap.nuovaPersona = true;					
					}
					(rap.tipoRappresentante = "PF");
					if (this.utente?.codiceFiscale === personaFisica?.infoAnagrafiche?.codFiscale?.toUpperCase()) {
						this.flagDelegaSeStesso = true;
					} else {
						this.flagDelegaSeStesso = false;
					}
					this.ref.detectChanges();
				}
			)
		);
	}

	personaGiuridicaReady(personaGiuridicaStatus: ComponentOutputStatus<PersonaGiuridicaDTO>) {
		console.log("[personaGiuridicaReady]", personaGiuridicaStatus);

		this.resetValidation();

		this.flagDelegaSeStesso = false;
		this.changesPersonaGiuridica$.next(
			personaGiuridicaStatus.mapValue(
				personaGiuridica => (rap: RappresentanteDTO) => {

					rap.personaGiuridica = personaGiuridica;

					rap.tipoRappresentante = "PG";

					this.rappresentanza.idSedeSelezionata = null;
					this.rappresentanza.idPersona = personaGiuridica.idPersonaGiuridica;
			
					if (personaGiuridica?.sedi?.length > 0) {
						this.rappresentanza.idSedeSelezionata = personaGiuridica.sedi[0].id;
					}

					if (this.delega == "nuovo") {
						this.isValidSedi = personaGiuridicaStatus.status;
						rap.nuovaPersona = true;

						rap.codiceRegione = personaGiuridica.codiceRegione;
					}
					this.ref.detectChanges();
				}
			)
		);
	}

	richiedenteComparator(m1: NaturaRichiedenteDTO, m2: NaturaRichiedenteDTO) {
		return (m1 || {}).codice == (m2 || {}).codice;
	}

	delegheComparator(m1: PersonaFisicaBaseDTO, m2: PersonaFisicaBaseDTO) {
		return (m1 || {}).codTipoDelega == (m2 || {}).codTipoDelega;
	}


	fromIdAndTipo(codice: string, tipoNaturaRichiedente: string) {
		const naturaRichiedente = new NaturaRichiedenteDTO();
		naturaRichiedente.codice = codice;
		naturaRichiedente.descrizione = tipoNaturaRichiedente;
		return naturaRichiedente;
	}

	onChangeGeneralContractor(event: MatCheckboxChange) {
		this.isGeneralContractor.emit(event.checked);
	}
}
